import { Segmented } from '../components/ui'
import type { ControlScheme } from './useCyclesInput'

interface Props {
  value: ControlScheme
  onChange: (scheme: ControlScheme) => void
  className?: string
}

/** Tap-to-turn or swipe; arrow keys and WASD always work. */
export function ControlSchemePicker({ value, onChange, className }: Props) {
  return (
    <Segmented
      label="Controls"
      value={value}
      onChange={onChange}
      options={[
        { value: 'tap', label: 'Tap to turn' },
        { value: 'swipe', label: 'Swipe' },
      ]}
      {...(className ? { className } : {})}
    />
  )
}
